// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleBylines_root__NaEL5","feature":"ArticleBylines_feature__40W6e"};